import { Config } from "@/modules/config"
import { LoggerType } from "@/modules/utils/loggerUtils"
import { create } from "@/modules/core/store"
import { StreamChat } from "stream-chat"

type ChatActions = {
  setChatClient: (client: StreamChat) => void
  setIsUserConnected: (isUserConnected: boolean) => void
  disconnectChatUser: () => Promise<boolean>
}

type ChatState = {
  chatClient: StreamChat
  isUserConnected: boolean
  actions: ChatActions
}

const useChatStore = create<ChatState>()((set) => ({
  chatClient: new StreamChat(Config.STREAM_CHAT_API_KEY),
  isUserConnected: false,
  actions: {
    setChatClient: (chatClient) => set({ chatClient }),
    setIsUserConnected: (isUserConnected) => set({ isUserConnected }),
    disconnectChatUser: async () => {
      try {
        await useChatStore.getState().chatClient.disconnectUser()
        set({ isUserConnected: false })
        return true
      } catch (error) {
        console.error(LoggerType.Chat + "Error disconnecting user", error)
        return false
      }
    },
  },
}))

export const useChatClient = () => useChatStore((state) => state.chatClient)
export const useIsUserConnected = () => useChatStore((state) => state.isUserConnected)
export const useChatStoreActions = () => useChatStore((state) => state.actions)
